/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioMetricsSchema = z.object({
  timelineEndDate: z.iso.date().nullish(),
  timelineStartDate: z.iso.date().nullish(),
});
